// extracted by mini-css-extract-plugin
module.exports = {"main-logo":"Home_main-logo__2kw_d","develop-portal":"Home_develop-portal__2yzgs","text-center":"Home_text-center__1q3fC"};